export default "/images/framework/WordPlayerEng.48247625.svg?48247625";